<template>
  <div class="col-12">
    <div class="col-sm-12 search-form-title mx-2">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row px-2">
        <div class="col-sm-6">
          <span class="span-title">{{ $t('street_lights.status') }}</span>
          <select
            v-model="status"
            class="form-select form-select-sm"
          >
            <option :value="null" />
            <option
              v-for="option in statusOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-6">
          <span class="span-title">{{ $t('street_lights.station') }}</span>
          <select
            id="lightStation"
            v-model="station"
            class="form-select form-select-sm"
          >
            <option :value="null">
              {{ $t('street_lights.select_station') }}
            </option>
            <option
              v-for="stationOption in stations"
              :key="stationOption.value"
              :value="stationOption.value"
            >
              {{ stationOption.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 px-2">
        <contract-filter
          ref="filter"
          :user="user"
          :show-only-my-contracts-option="true"
          @contract-set="setContract"
          @company-set="companySet"
        />
      </div>
      <div class="col-sm-12 px-2 pb-2 d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-primary  form-button"
        >
          {{ $t('ins_report.search') }}
        </button>
        <button
          type="reset"
          class="btn btn-danger  form-button"
        >
          {{ $t('ins_report.clear') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from "@/components/mixins/RestApiMixin"

export default {
    name: 'StreetLightSearch',
    components: {ContractFilter},
    mixins: [timeUtils, restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            IN_USE: 1,
            FAILURE: 2,
            NOT_IN_USE: 3,
            PLANNED: 4,
            contract: null,
            company: null,
            status: 1,
            stations: [],
            station: null,
            statusOptions: [
                {value: null, text: this.$t('observations.search_all')},
                {value: 1, text: this.$t('street_lights.in_use')},
                {value: 2, text: this.$t('street_lights.failure')},
                {value: 3, text: this.$t('street_lights.not_in_use')},
                {value: 4, text: this.$t('street_lights.planned')},
            ]
        }
    },
    mounted() {
        this.fetchStations()
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if (this.sign) {
                params.sign = this.sign.value
            }
            if (this.company) {
                params.company = this.company
            }
            if (this.status) {
                params.status = this.status
            }
            if (this.station) {
                params.station = this.station
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.status = null
            this.station = null
            this.$refs.filter.resetData()
        },
        fetchStations() {
            this.loading = true
            this.stations = []
            this.restFetch(this.powerStationUrl, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                response.data.forEach(station => {
                    this.stations.push({value: station.id, text: station.id + ' ' + station.street})
                })
            }
            this.loading = false
        },
    }
}
</script>
